import { gql } from "@apollo/client";
const CART = gql`
  query cart {
    cart {
      __typename
      ... on Cart {
        line_cart {
          id
          quantity
          total
          product {
            id
            name
            description
            price
            stock
            shine
            url_image
          }
        }
        total
      }
    }
  }
`;

const GET_TOTAL_OF_CART = gql`
  query getTotalOfCart {
    getTotalOfCart {
      __typename
      ... on CartTotal {
        total
      }
      ... on ResultError {
        status_code
        message
      }
    }
  }
`;
const CHECK_STOCK = gql`
  query {
    checkStock {
      __typename
      ... on ProductsWithoutStock {
        product {
          id
          name
        }
      }
      ... on ResultError {
        status_code
        message
      }
    }
  }
`;
export { CART, GET_TOTAL_OF_CART, CHECK_STOCK };
